import { TimePicker } from 'antd';
import { AppFormItem, isAfterDateValidator, isBeforeDateValidator } from 'shared/UI/UIKit/Form';
import type { unitOfTime } from 'moment';
import type { AppFormRuleRender } from 'shared/UI/UIKit/Form';
import type { TimeIntervalFieldsProps } from './types';
import { FILTER_FORM_NAMES } from '../../../constants';

const START_ITEM_NAME_PATH = [FILTER_FORM_NAMES.values, 0];
const END_ITEM_NAME_PATH = [FILTER_FORM_NAMES.values, 1];
const TIME_UNIT: unitOfTime.Diff = 'second';

export const TimeIntervalFields = ({
  onChange,
  focusRef,
  placeholderStart,
  placeholderEnd,
}: TimeIntervalFieldsProps) => {
  const startItemRule: AppFormRuleRender = ({ getFieldValue }) => {
    const validator = isBeforeDateValidator(true, getFieldValue(END_ITEM_NAME_PATH), {
      granularity: TIME_UNIT,
      variant: 'before',
      comparisonValueRequired: false,
      message: 'Начальное время должно быть меньше конечного',
    });
    return { validator };
  };

  const endItemRule: AppFormRuleRender = ({ getFieldValue }) => {
    const validator = isAfterDateValidator(true, getFieldValue(START_ITEM_NAME_PATH), {
      granularity: TIME_UNIT,
      variant: 'after',
      comparisonValueRequired: false,
      message: 'Конечное время должно быть больше начального',
    });
    return { validator };
  };

  return (
    <>
      <AppFormItem noStyle shouldUpdate>
        {({ getFieldValue }) => (
          <AppFormItem
            name={START_ITEM_NAME_PATH}
            marginless
            withoutExplain
            dependencies={[END_ITEM_NAME_PATH]}
            rules={[startItemRule]}
          >
            <TimePicker
              onChange={(value) => onChange([value, getFieldValue(END_ITEM_NAME_PATH)])}
              placeholder={placeholderStart}
              ref={focusRef}
            />
          </AppFormItem>
        )}
      </AppFormItem>
      <AppFormItem noStyle shouldUpdate>
        {({ getFieldValue }) => (
          <AppFormItem
            name={END_ITEM_NAME_PATH}
            marginless
            withoutExplain
            dependencies={[START_ITEM_NAME_PATH]}
            rules={[endItemRule]}
          >
            <TimePicker
              onChange={(value) => onChange([getFieldValue(START_ITEM_NAME_PATH), value])}
              placeholder={placeholderEnd}
            />
          </AppFormItem>
        )}
      </AppFormItem>
    </>
  );
};
